import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from '../components/layout/layout.component';
import { ListingComponent } from '../user-management/listing/listing.component';
import { UploadComponent } from '../shared/upload/upload.component';
import { FieldCorrectionRevampComponent } from '../shared/upload/field-correction-revamp/field-correction-revamp.component';

const routes: Routes = [
    {
        path: '', component: LayoutComponent,
        children: [
            {
                path: 'students',
                component: ListingComponent
            },
            {
                path: 'parents',
                component: ListingComponent
            },
            {
                path: 'assistants',
                component: ListingComponent
            },
            {
                path: 'staff',
                component: ListingComponent
            },
            {
                path: 'pending-requests',
                component: ListingComponent
            },
            {
                path: 'edit-requests',
                component: ListingComponent
            },
            {
                path: 'early-dismissal-requests',
                component: ListingComponent
            },
            {
                path: 'upload',
                component: UploadComponent
            },
            {
                path: 'field-correction',
                component: FieldCorrectionRevampComponent
            },
            {
                path: '',
                redirectTo: '/dashboard/students',
                pathMatch: 'full'
            },
            {
                path: 'dashboard',
                redirectTo: '/dashboard/students',
                pathMatch: 'full'
            },
          
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class DashboardRoutingModule { }